<template>
  <div id="user-create-tab-info">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full mt-4" label="Nome da conta" v-model="data.name" v-validate="'required'" name="name" />
          <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
          <vs-input class="w-full mt-4" label="Celular do administrador" v-model="data.phone" v-validate="'required'" v-mask="'(##) #####-####'" name="phone" />
          <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
          <vs-input class="w-full mt-4" label="Email do administrador" v-model="data.email" type="email" v-validate="'required|email'" name="email" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
          <div>
            <p class="selectLabel">Tipo da conta</p>
            <v-select :clearable="false" v-model="data.type" :options="typeOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
          </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">
          <div>
            <p class="selectLabelNew">Forma preferencial de logística</p>
            <v-select :clearable="false" v-model="data.logisticInfo" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
          </div>
          <div>
            <p class="selectLabelEnd">Operador logístico para esta conexão</p>
            <v-select :clearable="true" v-model="data.logisticOperatorConnection" :options="data.logisticOperators" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
          </div>
          <div>
            <p class="selectLabelEnd">Aplicar checklist ao criar lote para minha conta</p>
            <v-select :clearable="true" v-model="data.checklistConnection" :options="data.checklists" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
          </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="createConnection" :disabled="!validateForm">Cadastrar</vs-button>
          <vs-button class="ml-4 mt-2" color="warning" @click="resetData">Cancelar</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      options: [
        { id: 1, label: 'Coleta' },
        { id: 2, label: 'Entrega' }
      ],
      typeOptions: [
        { id: 1, label: 'Cliente' },
        { id: 2, label: 'Fornecedor' },
        { id: 3, label: 'Operador logístico' }
      ]
    }
  },
  props: {
    data: { Type: Object, default () { return {} } }
  },
  computed: {
    validateForm () { return !this.errors.any() }
  },
  methods: {
    resetData () {
      this.data.name = null
      this.data.phone = null
      this.data.email = null
      this.$router.push('/cadastro/conexoes/conexoes').catch(() => {})
    },
    createConnection () {
      if (!this.validateForm) return
      this.$emit('createConnection', this.data)
      this.resetData()
    }
  }
}
</script>

<style>
.selectLabel {
  font-size: 12px;
  margin-top: 15px;
  margin-left: 5px;
}
.selectLabelNew {
  font-size: 12px;
  margin-top: 17px;
  margin-left: 5px;
}
.selectLabelEnd {
  font-size: 12px;
  margin-top: -4px;
  margin-left: 5px;
}
</style>
